import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CarouselWrapperComponent } from '@usana/ux/cms';
import { DotcomTranslateComponent } from '../dotcom-translate/dotcom-translate.component';
import { PwpSectionComponent } from './pwp-section.component';

@NgModule({
    declarations: [PwpSectionComponent],
    imports: [
        CommonModule,
        RouterModule,
        DotcomTranslateComponent,
        CarouselWrapperComponent,
    ],
    exports: [PwpSectionComponent],
})
export class PwpSectionModule {}
